import Vue from "vue";
import Vuex from "vuex";

import {
  getNotice
} from "@/api/notice"

Vue.use(Vuex);
// const store = new Vuex.Store({
//   // state 状态, 即数据, 类似于vue组件中的data,
//   // 区别在于 data 是组件自己的数据, 而 state 中的数据整个vue项目的组件都能访问到
//   state: {
//     count: 101
//   }
// })

export default new Vuex.Store({
  state: {
    menuRouter: localStorage.getItem("menuRouter") ?
      JSON.parse(localStorage.getItem("menuRouter")) : [], // 路由
    token: localStorage.getItem("token") ? localStorage.getItem("token") : "", // 存储token
    userInfo: localStorage.getItem("userInfo") ?
      JSON.parse(localStorage.getItem("userInfo")) : "", //用户信息
    time: localStorage.getItem("time") ?
      JSON.parse(localStorage.getItem("time")) : 0, //7天免登录
    login: localStorage.getItem("login") ?
      JSON.parse(localStorage.getItem("login")) : 1, //登录状态
    loginShow: 0, //登录框
    read: localStorage.getItem("read") ?
      JSON.parse(localStorage.getItem("read")) : 0, //勾选阅读服务协议
    // 是否开启主播模式，原是局部变量，因为要根据权限判定初始化，因此改为vuex全局缓存，0未开启主播模式，1开启，默认为0
    liveTypes: localStorage.getItem("liveTypes") ?
      Number(localStorage.getItem("liveTypes")) : 0,
    // 项目全局的document.title以及favicon
    globalmMetaInfo: {
      name: "",
      favicon: ""
    },
    // 需要提醒的列表
    noticeList: [],
    intervalNoticeFn: null,
    orderTypes: localStorage.getItem("orderTypes") && localStorage.getItem("orderTypes") != 'undefined' ? JSON.parse(localStorage.getItem("orderTypes")) : {},
  },
  getters: {
    getToken(state) {
      return state.token || "";
    },
    getUserInfo(state) {
      return state.userInfo || "";
    },
    getLogin(state) {
      return state.login || 0;
    },
    getLoginShow(state) {
      return state.loginShow || 0;
    },
    getTime(state) {
      return state.time || 0;
    },
    getGlobalmMetaInfo(state) {
      return state.globalmMetaInfo;
    },
    getMenuRouter(state) {
      return state.menuRouter;
    },
  },
  mutations: {
    // 修改路由
    setMenuRoutes(state, menuRouter) {
      state.menuRouter = menuRouter;
      localStorage.setItem("menuRouter", JSON.stringify(menuRouter));
    },
    // 修改路由
    addMenuRoutes(state, newMenuRouter) {
      state.menuRouter.push(newMenuRouter);
      localStorage.setItem("menuRouter", JSON.stringify(state.menuRouter));
    },
    // 修改token
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    // 删除token
    delToken(state) {
      state.token = "";
    },
    // 删除7天免登录时间
    delTime(state) {
      state.time = 0;
    },
    // 用户信息
    setTime(state, time) {
      state.time = time;
      localStorage.setItem("time", JSON.stringify(time));
    },
    // 用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    // 是否登录
    setLogin(state, login) {
      state.login = login;
      localStorage.setItem("login", JSON.stringify(login));
    },
    // 删除登录状态
    delLogin(state) {
      state.login = false;
    },
    //登录框
    setLoginShow(state, loginShow) {
      state.loginShow = loginShow;
    },
    // 勾选阅读服务协议
    setRead(state, read) {
      state.read = read;
      localStorage.setItem("read", JSON.stringify(read));
    },
    // 设置是否开启主播模式
    setLiveTypes(state, liveTypes) {
      state.liveTypes = liveTypes;
      localStorage.setItem("liveTypes", liveTypes);
    },
    setGlobalmMetaInfo(state, metaInfo) {
      state.globalmMetaInfo = metaInfo;
    },
    setNoticeList(state, list) {
      state.noticeList = list
    },
    setOrderTypes(state, obj) {
      state.orderTypes = obj
      localStorage.setItem("orderTypes", JSON.stringify(obj));
    },
  },
  actions: {
    addMenuRoutes: ({
      commit,
      state
    }, newMenuData) => {
      // console.log(newMenuData,currentMenu,"state");
      const routers = state.menuRouter;
      routers.push(newMenuData);
      commit("setMenuRoutes", routers);
    },
    // 初始化通知弹框内容
    initNoticeList({
      state,
      commit
    }) {
      if (state.token != '') {
        getNotice({
          token: state.token
        }).then((res) => {
          commit('setNoticeList', res)
        })
      }
    },
    startNoticeInterval({
      state,
      dispatch
    }) {
      if (state.intervalNoticeFn) {
        clearInterval(state.intervalNoticeFn)
        state.intervalNoticeFn = null
      }
      // 每隔1分钟调取一次通知
      state.intervalNoticeFn = setInterval(() => {
        dispatch('initNoticeList')
      }, 10000)
    },
    stopNoticeInterval() {
      if (state.intervalNoticeFn) {
        clearInterval(state.intervalNoticeFn)
        state.intervalNoticeFn = null
      }
    },
    // 退出
    logout: ({
      state
    }) => {
      return new Promise((resolve, reject) => {
        state.login = 1;
        state.loginShow = 0;
        state.menuRouter = state.menuRouter.filter((item) => item.id != 99);
        state.token = "";
        state.userInfo = {
          avatar: "",
          nickname: "",
          is_password: "",
          mobile: "",
          token: "",
          rules: [],
        };
        state.noticeList = []
        state.time = 0;
        state.liveTypes = 0;
        state.orderTypes = {
          月付: "0",
          季付: "0",
          年付: "0"
        }
        localStorage.removeItem("menuRouter");
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("time");
        localStorage.removeItem("login");
        localStorage.removeItem("liveTypes");
        localStorage.removeItem("orderTypes");
        resolve();
      });
    },
  },
});